import { getState } from 'src/store/cns';
import {
  ACTIVE_DEPLOYMENT,
  callContractTransaction,
  callContractView,
} from './common';

// Contract Deployments
import ResolverDeployment from '../../contracts/deployments/Resolver.json';

export const registerSubdomain = async (
  domain: Array<string>,
  label: string,
  resolverAddress: string,
) => {
  const wallet = getState().wallet;
  await callContractTransaction('Registry', 'setSubnodeRecord', [
    domain,
    label,
    wallet?.address,
    resolverAddress.length > 0
      ? resolverAddress
      : ResolverDeployment[ACTIVE_DEPLOYMENT].address,
    '86400',
  ]);
};

export const setOwner = async (domain: Array<string>, newOwner: string) => {
  await callContractTransaction('Registry', 'setOwner', [domain, newOwner]);
};

export const getOwner = async (domain: Array<string>): Promise<string> => {
  const ttl = await callContractView('Registry', 'getOwner', [domain]);
  return ttl;
};

export const setTTL = async (domain: Array<string>, ttl: string) => {
  await callContractTransaction('Registry', 'setTTL', [domain, ttl]);
};

export const getTTL = async (domain: Array<string>): Promise<number> => {
  const ttl = await callContractView('Registry', 'getTTL', [domain]);
  return ttl;
};

export const getResolver = async (domain: Array<string>): Promise<string> => {
  const resolverAddress = await callContractView('Registry', 'getResolver', [
    domain,
  ]);
  if (resolverAddress === '0x0000000000000000000000000000000000000000') {
    return '';
  }

  return resolverAddress;
};

export const setResolver = async (
  domain: Array<string>,
  resolverAddress: string,
) => {
  await callContractTransaction('Registry', 'setResolver', [
    domain,
    resolverAddress,
  ]);
};

export const setApprovalForAll = async (
  operator: string,
  approved: boolean,
) => {
  await callContractTransaction('Registry', 'setApprovalForAll', [
    operator,
    approved,
  ]);
};
